// extracted by mini-css-extract-plugin
export default {"toolTitle":"i7M2Cu","mobileIllustration":"C1V9_Q"};